import cx from 'classnames';
import { formatDistanceToNow } from 'date-fns';

import typography from '@shared/styles/typography.scss';
import styles from './Notification.scss';
import type { Message } from './apiHelpers';

interface NotificationProps {
  notification: Message;
}

const relativeTimestamp = (created_at: string) => {
  return formatDistanceToNow(new Date(created_at), {
    addSuffix: true,
  });
};

export const Notification = ({ notification }: NotificationProps) => {
  return (
    <div className={styles.notification}>
      <div
        className={cx(styles.status, {
          [styles.unread]: !notification.readAt,
        })}
      />
      <div className={styles.notificationContent}>
        <div className={cx(typography.t3_12, styles.userAndTime)}>
          <div>
            {notification.user.firstName} {notification.user.lastName}
          </div>

          <div>{relativeTimestamp(notification.createdAt)}</div>
        </div>

        <span className={cx(typography.c3_20, styles.truncatedMessage)}>
          {notification.message}
        </span>
      </div>
    </div>
  );
};
